export const WindowProvider = 'Window';
